// LIBRARY
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col, Form, Input } from 'antd';
import SearchPager from 'shared_components/search_pager';
import PageTitle from 'shared_components/page_title';
// eslint-disable-next-line import/no-extraneous-dependencies
import { PlusOutlined } from '@ant-design/icons';
import { GLOBAL_TABLE_PAGE_SIZE } from 'global_config/constant-global';
import FormDrawer from './form_drawer/index.jsx';
import FormDrawerUpdate from './form_drawer/index.jsx';
import UserRightsTable from './table';
import { getUserTypes } from 'services/settings/userType';
import { getModules } from 'services/settings/userRights';
import { showMessage } from 'services/settings/message';
const { Search } = Input;
const { useForm } = Form;

function UserRights(){
	const [pageSize, setPageSize] = useState(GLOBAL_TABLE_PAGE_SIZE);
	const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
	const [isDisplayAddForm, setIsDisplayAddForm] = useState(false);
	const [isDisplayUpdateForm, setIsDisplayUpdateForm] = useState(false);
	const [userRights, setUserRights] = useState([]);
	const [filteredUserRights, setFilteredUserRights] = useState([]);
	const [modules, setModules] = useState([]);
	const [selectedId, setSelectedId] = useState(null);
	useEffect(()=>{
		fetchUserTypes();
		fetchModules();
	},[]);




	const fetchUserTypes = async () => {
			setIsLoading(true);
			const response = await getUserTypes();
			// @ts-ignore
			if (response.status === 200) {
				setUserRights(response.data);
				setFilteredUserRights(response.data);
			}
			console.log('response', response.data);
			setIsLoading(false);
		}

	const fetchModules = async () => {
		
		const modules = await getModules();

		if(modules && modules.length > 0){
			const targetModules = modules.map(item=>{
				const { moduleActions } = item;
				return({
					moduleID: item.moduleID,
					moduleName: item.moduleName,
					view: moduleActions ? moduleActions.includes('View') : false,
					create: moduleActions ? moduleActions.includes('Create') : false,
					edit: moduleActions ? moduleActions.includes('Edit') : false,
					print: moduleActions ? moduleActions.includes('Print') : false,
				});
			});

			setModules(targetModules);
		}
	}

	const findUserType = (searchValue) => {
		setCurrentPage(1); // Reset to first page on search
		if (!searchValue || searchValue.trim() === '') {
			setFilteredUserRights(userRights);
		} else {
			const filtered = userRights.filter(item =>
				item.userType && item.userType.toLowerCase().includes(searchValue.toLowerCase())
			);
			setFilteredUserRights(filtered);

			if (filtered.length === 0) {
				showMessage('M0001');
			}
		}
	}

  const onClickAdd = () => {
		setIsLoading(true);
		setIsDisplayAddForm(true);
  }
	
  const onChangePager = (size) => {
		setPageSize(size);
  } 

  const onDblClickTableRow = (record) => {
		setIsDisplayUpdateForm(true);
		setSelectedId(record.userTypeID);
  }

  const onTableChange = (pagination) => {
		setCurrentPage(pagination.current);
  }

  const onCloseForm = () => {
	setIsDisplayAddForm(false);
	setIsDisplayUpdateForm(false);
	setIsLoading(false);
  }

		return (
			<div>
				<Row justify="center" style={{ marginTop: 30 }}>
					<PageTitle pageTitle="USER TYPES" />
				</Row>

				<Row
					style={{
						display: 'flex',
						gap: '10px',
						justifyContent: 'space-between',
						alignItems: 'end',
						marginTop: 30,
					}}
				>
					<Col style={{ display: 'flex', textAlign: 'left', gap: '10px' }}>
						<div>
							<Search
								maxLength={20}
								onSearch={findUserType}
								allowClear
								placeholder='USER TYPE'
								style={{ width: 300 }}
							/>
						</div>
					</Col>
					<Col style={{ display: 'flex', gap: '10px', justifyContent: 'end' }}>
						<Button
							shape="round"
							type="primary"
							onClick={onClickAdd}
						>
							<PlusOutlined />
							ADD USER TYPE
						</Button>
					</Col>
				</Row>
				<Row>
					<Col span={24}>
						<SearchPager
							pageSize={pageSize}
							pageTotal={filteredUserRights.length}
							handleChangeSize={onChangePager}
							currentPage={currentPage}
						/>
					</Col>
				</Row>
				<UserRightsTable
					data={filteredUserRights}
					pageSize={pageSize}
					loading={isLoading}
					onRowDblClick={onDblClickTableRow}
					onTableChange={onTableChange}
					currentPage={currentPage}
				/>
				<FormDrawer
					visible={isDisplayAddForm}
					onClose={onCloseForm}
					modules={modules}
					onSuccess={() => {
						onCloseForm();
						fetchUserTypes();
					}}
				/>	
				<FormDrawerUpdate 
          			visible={isDisplayUpdateForm}
          			onClose={onCloseForm}
					modules={modules}
					id={selectedId}
					onSuccess={() => {
						onCloseForm();
						fetchUserTypes();
					}}
				/>
			</div>
		);
	// }
}

export default UserRights;